import { UiPalette } from '../types/UiPalette.type';

export class ProgressSegment {
  value: number;
  label?: string;
  color?: UiPalette;
  excludeFromTotal?: boolean;
}
